module.exports = __webpack_public_path__ + "img/backgroundImage.5baf0d93.png";